import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'
import Sticky from 'react-stickynode'

const GridItem = observer(({
  position,
  style = {},
  children,
  settings,
  className = '',
  styleClassName = '',
  component,
  sticky = false,
  isScrollable = false,
  noGrid = false,
  compactType,
  id,
  ...props
}) => {
  let Comp = children
  const rowH = settings.ROW_HEIGHT || 20
  if (sticky) {
    Comp = <Sticky innerZ={1999}>{children}</Sticky>
  }
  if (noGrid) {
    return (
      <div
        className={cn(className, styleClassName)}
        style={{ height: '100%' }}
      >
        {Comp}
      </div>
    )
  }
  const _style = {
    gridRow: compactType ? 'auto' : `${((position.y != null && position.y + 1) || 'auto')} / span ${position.h}`,
    gridColumn:
      ((position.x != null && position.x + 1) || 'auto') +
      '/ span ' +
      Math.ceil(position.w),
    position: 'relative',
    overflowX: 'hidden',
    overflowY: isScrollable ? 'auto' : 'hidden',
    minHeight: (compactType && position.h * rowH) || 'none',
    maxHeight: (position.maxExpandH !== Infinity && (compactType && position.maxExpandH * rowH)) || 'none',
    height: '100%',
    //        maxHeight: '100%',
    ...style
  }
  return (
    <div
      key={component?.id || id}
      className={cn('GridItem', className, styleClassName, component)}
      style={_style}
      {...props}
    >
      {Comp}
    </div>
  )
})

export default GridItem
